<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    ثبت پست سازمانی
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : orgJobModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="orgJobModel.title" @input="v$.orgJobModel.title.$touch()" :class="{invalid:v$.orgJobModel.title.$error}">
                        <p class="text-danger" v-if="v$.orgJobModel.title.required.$invalid && v$.orgJobModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>


                    <button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateOrgJob">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
    </div>

    <Help-Menu title="معرفی اپلیکیشن تسکینو" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
    <Help-Menu title="تعریف پست سازمانی و تعیین سطوح دسترسی کاربران" keyEn="orgJob"  v-if="isKarnegasht==true"></Help-Menu>
   
</template>
<script>
import useVuelidate from '@vuelidate/core'
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                orgJobModel: {
                    code: "",
                    title: null,
                    orgJobId: 0,
                    userId: 0,
                    parentId: this.$route.params.parentId,
                    levelId: 0,
                    orgUnitId:0
                },

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
          
        },
        methods: {
            
            CreateOrgJob() {
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.$store.dispatch("CreateOrgJob", this.orgJobModel);
                }
               
            },
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
           
        },

        validations: {
            orgJobModel: {
                title: {
                    required
                },
            }


        },
		mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		},
    };
</script>
